const Rounded = {
  square: "square",
  sm: "sm",
  lg: "lg"
};
const Variant = {
  elevation: "elevation",
  outlined: "outlined"
};
const Elevation = {
  none: "none",
  low: "low",
  mid: "mid",
  high: "high"
};

export { Elevation, Rounded, Variant };
//# sourceMappingURL=types.js.map
